import React, { useEffect, useState } from 'react';
import { Box, Button, Grid, useTheme, Typography, Breadcrumbs, Tabs, Tab, TableBody, TableHead, Table, TableContainer, TextField } from '@mui/material';
import { useDispatch } from 'react-redux';
import usePageLoader from '../../Redux/hooks/usePageLoader';
import useSnackBar from '../../Redux/hooks/useSnackBar';
import FilterListIcon from "@mui/icons-material/FilterList";
import AddIcon from "@mui/icons-material/Add";
import { makeStyles } from 'tss-react/mui';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import CommonAutoComplete from '../../Component/Common/CommonAutoComplete';
import { useConfirm } from 'material-ui-confirm';
import CustomDrawer from '../../Component/Common/CustomDrawer';
import ViewDocument from '../../Component/Documents/ViewDocument';
import AddUpdateDocument from '../../Component/Documents/AddUpdateDocument';
import { monthsOption, useCommonStyles } from '../../utils';
import CommonPagination from '../../Component/Common/CommonPagination';
import IconBackground from '../../Component/Common/IconBackground';
import StyledTableCell from '../../Component/Common/StyledTableCell';
import StyledTableRow from '../../Component/Common/StyledTableRow';
import NoDataFound from '../../Component/Common/NoDataFound';
import DownloadIcon from '@mui/icons-material/Download';
import { deleteDocument, downloadSheet, getDocumentById, getDocuments, getDocumentsByType, getPoDocumentsByAdvanceLicense, getTotalProduction } from '../../Redux/Actions/Documents';
import ErrorHandler from '../../lib/errorHandler';
import { standardDateFormat } from '../../lib/standardDateFormat';
import Assets from '../../Component/Common/Assets';
import axios from 'axios';
import { useAppSelector } from '../../Redux/app/hooks';
import { downloadPO } from '../../Redux/Actions/PurchaseOrder';
import downloadFileFromBlob from '../../lib/downloadFileFromBlob';
import localStoreUtil from '../../ApiSetUp/localstore.util';
import { BaseUrl, LOGIN_TOKEN } from '../../ApiSetUp/AuthApi';
import StatusButton from '../../Component/Common/StatusButton';

const useStyles = makeStyles()((theme) => ({
    customTabStyle: {
        margin: "30px",
        "& .MuiTabs-flexContainer": {
            gap: "10px",
        },
        "& .MuiTab-root": {
            backgroundColor: "transparent",
            alignItems: "start",
            color: "#555151",
            fontFamily: "Satoshi-Light",
            minWidth: "0px",
            fontSize: "18px"
        },
        "& .Mui-selected": {
            fontFamily: "Satoshi-Bold",
            color: theme.palette.primary.main
        },
        "& .MuiTabs-indicator": {
            display: "none"
        }
    },
}))

const poDocumentSteps = [
    { name: "Light bill", value: 0, },
    { name: "Company doc", value: 1, },
    { name: "Stock Statement", value: 2, },
    { name: "Insurance", value: 3, },
    { name: "Bank statement", value: 4, },
    { name: "PF Documents", value: 5, },
    { name: "Add Salary", value: 6, },
    { name: "Bank Interest", value: 7, },
    { name: "Gas", value: 8, },
    { name: "Production", value: 9, },
    { name: "Tally", value: 10, },
    { name: "Cost sheet", value: 11, },
    { name: "Advance license", value: 12, },
];

const Documents = () => {
    // ============== Hooks ==============
    const theme = useTheme();
    const { classes } = useCommonStyles();
    const { classes: muiClasses } = useStyles();
    const dispatch = useDispatch();
    const setFullPageLoader = usePageLoader();
    const { setSnackBar } = useSnackBar();
    const confirmDialogue = useConfirm();

    // =============== States ===============
    const [value, setValue] = useState(0);
    const [activeTab, setActiveTab] = useState({ name: "Light bill", value: 0, },);
    const [yearOptions, setYearOptions] = useState([]);
    const [selectedYear, setSelectedYear] = React.useState(null);
    const [data, setData] = useState({});
    const [selectedItem, setSelectedItem] = useState({});
    const [page, setPage] = useState(1);
    const [listData, setListData] = useState({});
    const [poDocumentByLicenseData, setPoDocumentByLicenseData] = useState({});
    const [isOpenDrawer, setIsOpenDrawer] = useState(false);
    const [isOpenViewDrawer, setIsOpenViewDrawer] = useState(false);


    const breadcrumbs = [
        <Typography color={theme.palette.bgBlack.main} sx={{ opacity: "70%", cursor: "pointer" }} fontFamily={'Satoshi-Medium'} onClick={() => { }}>
            Documents
        </Typography>,
        <Typography color={theme.palette.bgBlack.main} fontFamily={'Satoshi-Medium'}>
            {activeTab?.name}
        </Typography>,
    ];

    const getPermissionList = useAppSelector((state) => state?.auth?.getRolePermission);
    // =============== Handler ===============

    let PerPage = 10
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleChangePage = (e, p) => {
        setPage(p);
    };

    const sortByFinancialYear = (data) => {
        const financialYearOrder = [4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3];

        return data?.sort((a, b) =>
            financialYearOrder.indexOf(a.month) - financialYearOrder.indexOf(b.month)
        );
    };

    // ============= get Inventories List API =============
    const _getDocuments = async () => {
        setFullPageLoader(true);
        let response;
        let body = {
            "year": [0, 2, 4, 5, 6, 7, 8, 9, 10, 11].includes(activeTab?.value) ? +selectedYear.id : null,
            "docsType": activeTab?.value,
            "limit": [0, 2, 4, 5, 6, 7, 8, 9, 10, 11].includes(activeTab?.value) ? 12 : PerPage,
            "page": page
        }
        response = await dispatch(getDocumentsByType(body));
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            if (response?.payload?.data) {
                setListData(response?.payload?.data)
            }
            setFullPageLoader(false);
        }
        setFullPageLoader(false);
    };

    const _getTotalProduction = async () => {
        setFullPageLoader(true);
        let response;
        let body = {
            "year": +selectedYear.id,
        }
        response = await dispatch(getTotalProduction(body));
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            if (response?.payload?.data) {
                setListData(response?.payload?.data)
            }
            setFullPageLoader(false);
        }
        setFullPageLoader(false);
    };
    // ============= Get By Id Inventory Field API =============
    const _getDocumentById = async (id, istrue) => {
        setFullPageLoader(true);
        let response;
        let body = `/${id}`
        response = await dispatch(getDocumentById(body));
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            if (response?.payload?.data?.response) {
                setSelectedItem(response?.payload?.data?.response)
                let res = response?.payload?.data?.response
                setIsOpenViewDrawer(true)
            }
            setFullPageLoader(false);
        }
        setFullPageLoader(false);
    };

    const _getPoDocumentsByAdvanceLicense = async (advanceLicenseNo, page, PerPage) => {
        if (activeTab.value == 12) {
            setFullPageLoader(true);
            let response;
            let body = {
                "limit": PerPage ? PerPage : 5,
                "page": page ? page : 1,
                "advanceLicenseNo": advanceLicenseNo,
            }
            response = await dispatch(getPoDocumentsByAdvanceLicense(body));
            let error = await ErrorHandler(response, setSnackBar);
            if (error) {
                if (response?.payload?.data) {
                    setPoDocumentByLicenseData(response?.payload?.data)
                }
                setFullPageLoader(false);
            }
            setFullPageLoader(false);
        }
    };



    const _downloadExcel = async () => {
        try {
            setFullPageLoader(true);
            let login_token = await localStoreUtil.get_data(LOGIN_TOKEN);
            const response = await axios.post(
                `${BaseUrl}admin/downloadSheet`,
                { year: +selectedYear?.id || null },
                {
                    responseType: "blob",  // Ensure response is received as a file
                    headers: {
                        Authorization: `Bearer ${login_token}`,
                        "Content-Type": "application/json",
                    },
                }
            );
            if (!response.data || response.data.size === 0) {
                console.error("Empty file received, check API response");
                return;
            }
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `CostSheetData-${selectedYear?.id}.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

        } catch (error) {
            console.error("Error fetching yearly totals:", error);
        } finally {
            setFullPageLoader(false);
        }
    };
    // ============= Delete Inventory Field API =============
    const _deleteDocument = async (id) => {
        setFullPageLoader(true);
        let response;
        let body = `/${id}`
        response = await dispatch(deleteDocument(body));
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            if (response?.payload?.data?.response) {
                setSnackBar("success", response?.payload?.message)
                _getDocuments();
            }
            setFullPageLoader(false);
        }
        setFullPageLoader(false);
    };

    // ============= Use Effects API =============
    useEffect(() => {
        if (selectedYear?.id && activeTab?.value !== 11) {
            _getDocuments()
        }
    }, [selectedYear, activeTab, page])

    useEffect(() => {
        if (activeTab?.value == 11 && selectedYear?.id) {
            _getTotalProduction()
        }
    }, [activeTab, selectedYear])

    useEffect(() => {
        setPage(1)
    }, [activeTab])

    useEffect(() => {
        const currentYear = new Date().getFullYear();
        const years = Array.from({ length: 5 }, (_, i) => {
            const startYear = currentYear - i;
            return {
                id: `${startYear}`,
                name: `${startYear}`,
            };
        });
        setYearOptions(years);
        setSelectedYear(years[0]);
    }, []);


    return (
        <Box display={"flex"}>
            <Box sx={{ minWidth: "275px", height: "calc(100vh - 84px)", overflow: "auto", backgroundColor: "#E2E4F8" }}>
                <Tabs value={value} onChange={handleChange} className={muiClasses.customTabStyle}
                    orientation="vertical">
                    {poDocumentSteps.map((ele, index) => (
                        <Tab key={index} onClick={() => setActiveTab(ele)} label={ele.name} />
                    ))}
                </Tabs>
            </Box>
            <Grid container padding={"25px"} spacing={2} maxHeight={"calc(100vh - 84px)"} height={'fit-content'} overflow={"auto"} alignItems={"start"}>
                <Grid item xs={12} display={"flex"} justifyContent={"space-between"} alignItems={"end"} flexWrap={'wrap'}>
                    <Box>
                        <Typography fontFamily={"Satoshi-Bold"} fontSize={"28px"}>{activeTab?.name}</Typography>
                        <Breadcrumbs
                            separator={<NavigateNextIcon fontSize="small" />}
                            aria-label="breadcrumb"
                        >
                            {breadcrumbs}
                        </Breadcrumbs>
                    </Box>
                    <Box display="flex" gap={1} flexWrap={'wrap'}>
                        {[0, 2, 4, 5, 6, 7, 8, 9, 10, 11].includes(activeTab?.value) &&
                            <CommonAutoComplete
                                clearIcon={false}
                                width={"100px"}
                                options={yearOptions || []}
                                getOptionLabel={(option) => option?.name || ""}
                                value={selectedYear || null}
                                onChange={(e, newValue) => setSelectedYear(newValue)}
                                optionsMargin={1}
                                sx={{
                                    padding: "2px", "& .MuiOutlinedInput-root": {
                                        paddingRight: "2px !important"
                                    }
                                }}
                                isReadOnly={true}
                            />
                        }
                        {/* <Button className={classes.cancelButton} startIcon={<FilterListIcon />}>
                            Filters
                        </Button> */}
                        {[11].includes(activeTab?.value) &&
                            <Button className={classes.cancelButton} onClick={() => _downloadExcel()} startIcon={<DownloadIcon />}>
                                Download
                            </Button>
                        }
                        {getPermissionList?.editPermission?.includes('Documents') &&
                            ![11].includes(activeTab?.value) &&
                            <Button className={classes.saveButton} startIcon={<AddIcon />} onClick={() => setIsOpenDrawer(true)}>
                                Add New Item
                            </Button>
                        }
                    </Box>
                </Grid>
                <Grid item xs={12} width={'100px'} >
                    {activeTab.value == 0 ?
                        <LightBillTable listData={listData} _deleteDocument={_deleteDocument} _getDocumentById={_getDocumentById} />
                        :
                        activeTab.value == 9 ?
                            <ProductionTable listData={listData} _deleteDocument={_deleteDocument} _getDocumentById={_getDocumentById} />
                            :
                            <Box sx={{ borderRadius: "26px", border: "1px solid", backgroundColor: theme.palette.bgWhite.main, borderColor: "#c8d3d96e", borderTop: "none" }}>
                                <TableContainer>
                                    <Table sx={{ borderBottom: '1px solid #c8d3d96e' }}>
                                        <TableHead>
                                            <StyledTableRow isHeader style={{ backgroundColor: "#E9E9E9" }}>
                                                {[12].includes(activeTab?.value) && <StyledTableCell>SR.</StyledTableCell>}
                                                {[5].includes(activeTab?.value) && <StyledTableCell>Receipt Number</StyledTableCell>}

                                                {[0, 2, 4, 5, 6, 7, 8, 9, 10, 11].includes(activeTab?.value) && <StyledTableCell>Month</StyledTableCell>}

                                                {[0].includes(activeTab?.value) && <StyledTableCell>Unit</StyledTableCell>}
                                                {[0, 5, 7, 8].includes(activeTab?.value) && <StyledTableCell>Amount</StyledTableCell>}
                                                {[0].includes(activeTab?.value) && <StyledTableCell>Location</StyledTableCell>}

                                                {[1].includes(activeTab?.value) && <StyledTableCell>Document Name</StyledTableCell>}
                                                {[1].includes(activeTab?.value) && <StyledTableCell>Expiry Date</StyledTableCell>}

                                                {[3].includes(activeTab?.value) && <StyledTableCell>Policy Number</StyledTableCell>}
                                                {[3].includes(activeTab?.value) && <StyledTableCell>start Date</StyledTableCell>}
                                                {[3].includes(activeTab?.value) && <StyledTableCell>End Date</StyledTableCell>}
                                                {[3].includes(activeTab?.value) && <StyledTableCell>Assured Amount</StyledTableCell>}
                                                {[3].includes(activeTab?.value) && <StyledTableCell>Purpose</StyledTableCell>}
                                                {[3].includes(activeTab?.value) && <StyledTableCell>Company Name</StyledTableCell>}

                                                {[5].includes(activeTab?.value) && <StyledTableCell>Challan</StyledTableCell>}
                                                {[5].includes(activeTab?.value) && <StyledTableCell>Receipt</StyledTableCell>}
                                                {[5].includes(activeTab?.value) && <StyledTableCell>Form 1</StyledTableCell>}

                                                {[6].includes(activeTab?.value) && <StyledTableCell>S1</StyledTableCell>}
                                                {[6].includes(activeTab?.value) && <StyledTableCell>S2</StyledTableCell>}
                                                {[6].includes(activeTab?.value) && <StyledTableCell>S3</StyledTableCell>}
                                                {[6].includes(activeTab?.value) && <StyledTableCell>S4</StyledTableCell>}
                                                {[6].includes(activeTab?.value) && <StyledTableCell>S5</StyledTableCell>}

                                                {[9].includes(activeTab?.value) && <StyledTableCell>C1</StyledTableCell>}
                                                {[9].includes(activeTab?.value) && <StyledTableCell>C2</StyledTableCell>}
                                                {[9].includes(activeTab?.value) && <StyledTableCell>C3</StyledTableCell>}
                                                {[9].includes(activeTab?.value) && <StyledTableCell>C4</StyledTableCell>}
                                                {[9].includes(activeTab?.value) && <StyledTableCell>C5</StyledTableCell>}
                                                {[9].includes(activeTab?.value) && <StyledTableCell>C6</StyledTableCell>}
                                                {[9].includes(activeTab?.value) && <StyledTableCell>in (KG)</StyledTableCell>}
                                                {[9].includes(activeTab?.value) && <StyledTableCell>in (Sqmt)</StyledTableCell>}

                                                {[7].includes(activeTab?.value) && <StyledTableCell>Bank Charge</StyledTableCell>}
                                                {[6, 7].includes(activeTab?.value) && <StyledTableCell>Total</StyledTableCell>}
                                                {[8].includes(activeTab?.value) && <StyledTableCell>Quantity</StyledTableCell>}

                                                {[11].includes(activeTab?.value) && <StyledTableCell>Production</StyledTableCell>}
                                                {[11].includes(activeTab?.value) && <StyledTableCell>Salary</StyledTableCell>}
                                                {[11].includes(activeTab?.value) && <StyledTableCell>Bank</StyledTableCell>}
                                                {[11].includes(activeTab?.value) && <StyledTableCell>Light bill</StyledTableCell>}
                                                {[11].includes(activeTab?.value) && <StyledTableCell>PF</StyledTableCell>}
                                                {[11].includes(activeTab?.value) && <StyledTableCell>Gas</StyledTableCell>}
                                                {[11].includes(activeTab?.value) && <StyledTableCell>Total</StyledTableCell>}

                                                {[12].includes(activeTab?.value) && <StyledTableCell>
                                                    <Typography fontFamily={"Satoshi-Bold"} width={"100px"} whiteSpace={"wrap"}> Advance License Number
                                                    </Typography>
                                                </StyledTableCell>}
                                                {[12].includes(activeTab?.value) && <StyledTableCell>
                                                    <Typography fontFamily={"Satoshi-Bold"} width={"100px"} whiteSpace={"wrap"}>Advance Licence Date
                                                    </Typography>
                                                </StyledTableCell>}
                                                {[12].includes(activeTab?.value) && <StyledTableCell>
                                                    <Typography fontFamily={"Satoshi-Bold"} width={"100px"} whiteSpace={"wrap"}>
                                                        Import Total Quantity
                                                    </Typography>
                                                </StyledTableCell>}
                                                {[12].includes(activeTab?.value) && <StyledTableCell>
                                                    <Typography fontFamily={"Satoshi-Bold"} width={"100px"} whiteSpace={"wrap"}>
                                                        Total Value
                                                    </Typography>
                                                </StyledTableCell>}
                                                {[12].includes(activeTab?.value) && <StyledTableCell>
                                                    <Typography fontFamily={"Satoshi-Bold"} width={"100px"} whiteSpace={"wrap"}>
                                                        Import USE Quantity
                                                    </Typography>
                                                </StyledTableCell>}
                                                {[12].includes(activeTab?.value) && <StyledTableCell>
                                                    <Typography fontFamily={"Satoshi-Bold"} width={"100px"} whiteSpace={"wrap"}>
                                                        USE Value                                                    </Typography>
                                                </StyledTableCell>}
                                                {[12].includes(activeTab?.value) && <StyledTableCell>
                                                    <Typography fontFamily={"Satoshi-Bold"} width={"100px"} whiteSpace={"wrap"}>
                                                        Import Balance Quantity                                                    </Typography>
                                                </StyledTableCell>}
                                                {[12].includes(activeTab?.value) && <StyledTableCell>
                                                    <Typography fontFamily={"Satoshi-Bold"} width={"100px"} whiteSpace={"wrap"}>
                                                        Balance Value
                                                    </Typography>
                                                </StyledTableCell>}

                                                {/* {[12].includes(activeTab?.value) && <StyledTableCell>CIF Value</StyledTableCell>} */}
                                                {[12].includes(activeTab?.value) && <StyledTableCell>Export Total Quantity</StyledTableCell>}

                                                {[12].includes(activeTab?.value) && <StyledTableCell>
                                                    <Typography fontFamily={"Satoshi-Bold"} width={"100px"} whiteSpace={"wrap"}>
                                                        Total Value
                                                    </Typography>
                                                </StyledTableCell>}
                                                {/* {[12].includes(activeTab?.value) && <StyledTableCell>FOB Value</StyledTableCell>} */}
                                                {[12].includes(activeTab?.value) && <StyledTableCell>Export USE Quantity</StyledTableCell>}
                                                {[12].includes(activeTab?.value) && <StyledTableCell>USE Value</StyledTableCell>}
                                                {[12].includes(activeTab?.value) && <StyledTableCell>Export Balance Quantity</StyledTableCell>}
                                                {[12].includes(activeTab?.value) && <StyledTableCell>Balance Value</StyledTableCell>}
                                                {[0, 1, 2, 3, 4, 10, 12].includes(activeTab?.value) && <StyledTableCell>documents</StyledTableCell>}
                                                {[12].includes(activeTab?.value) && <StyledTableCell>Status</StyledTableCell>}
                                                {![11].includes(activeTab?.value) && <StyledTableCell>Action</StyledTableCell>}
                                            </StyledTableRow>
                                        </TableHead>
                                        <TableBody>
                                            {listData?.response?.length > 0 ?
                                                ([0, 2, 4, 5, 6, 7, 8, 9, 10, 11].includes(activeTab?.value) ? sortByFinancialYear(listData?.response) : listData?.response)?.map((row, index) => (
                                                    <React.Fragment key={index}>
                                                        <StyledTableRow>
                                                            {[5].includes(activeTab?.value) && <StyledTableCell>{row?.receiptNumber ? row?.receiptNumber : "NA"}</StyledTableCell>}
                                                            {[12].includes(activeTab?.value) && <StyledTableCell> {index + 1 + (page - 1) * PerPage}</StyledTableCell>}

                                                            {[0, 2, 4, 5, 6, 7, 8, 9, 10, 11].includes(activeTab?.value) && <StyledTableCell>{row?.month ? monthsOption?.find((ele) => row?.month == ele?.id)?.name : "NA"}</StyledTableCell>}

                                                            {[0].includes(activeTab?.value) && <StyledTableCell>{row?.unit || "NA"}</StyledTableCell>}
                                                            {[0, 5, 7, 8].includes(activeTab?.value) && <StyledTableCell>{Number(row?.amount_1).toFixed(3) || "NA"}</StyledTableCell>}
                                                            {[0].includes(activeTab?.value) && <StyledTableCell>{row?.location || "NA"}</StyledTableCell>}

                                                            {[1].includes(activeTab?.value) && <StyledTableCell>{row?.documentName || "NA"}</StyledTableCell>}
                                                            {[1].includes(activeTab?.value) && <StyledTableCell>{row?.expiryDate ? standardDateFormat(row?.expiryDate) : "NA"}</StyledTableCell>}

                                                            {[3].includes(activeTab?.value) && <StyledTableCell>{row?.policyNumber || "NA"}</StyledTableCell>}
                                                            {[3].includes(activeTab?.value) && <StyledTableCell>{row?.startDate ? standardDateFormat(row?.startDate) : "NA"}</StyledTableCell>}
                                                            {[3].includes(activeTab?.value) && <StyledTableCell>{row?.endDate ? standardDateFormat(row?.endDate) : "NA"}</StyledTableCell>}
                                                            {[3].includes(activeTab?.value) && <StyledTableCell>{Number(row?.amount_2 ).toFixed(3) || "NA"}</StyledTableCell>}
                                                            {[3].includes(activeTab?.value) && <StyledTableCell>{row?.purpose || "NA"}</StyledTableCell>}
                                                            {[3].includes(activeTab?.value) && <StyledTableCell>{row?.companyName || "NA"}</StyledTableCell>}

                                                            {[5].includes(activeTab?.value) && <StyledTableCell>
                                                                {row?.challanDocument ?
                                                                    <Box display={"flex"} gap={1} alignItems={"center"}>
                                                                        <Assets absolutePath={true} src={`/assets/img/Pdf.svg`} />
                                                                        {row?.challanDocument?.split("/").pop()}
                                                                    </Box>
                                                                    : "NA"
                                                                }
                                                            </StyledTableCell>
                                                            }
                                                            {[5].includes(activeTab?.value) && <StyledTableCell>
                                                                {row?.recieptDocument ?
                                                                    <Box display={"flex"} gap={1} alignItems={"center"}>
                                                                        <Assets absolutePath={true} src={`/assets/img/Pdf.svg`} />
                                                                        {row?.recieptDocument?.split("/").pop()}
                                                                    </Box>
                                                                    : "NA"
                                                                }
                                                            </StyledTableCell>
                                                            }
                                                            {[5].includes(activeTab?.value) && <StyledTableCell>
                                                                {row?.form_1_Document ?
                                                                    <Box display={"flex"} gap={1} alignItems={"center"}>
                                                                        <Assets absolutePath={true} src={`/assets/img/Pdf.svg`} />
                                                                        {row?.form_1_Document?.split("/").pop()}
                                                                    </Box>
                                                                    : "NA"
                                                                }
                                                            </StyledTableCell>
                                                            }

                                                            {[6].includes(activeTab?.value) && <StyledTableCell>{row?.salary_1 % 1 === 0 ? row?.salary_1 : row?.salary_1?.toFixed(2) || "NA"}</StyledTableCell>}
                                                            {[6].includes(activeTab?.value) && <StyledTableCell>{row?.salary_2 % 1 === 0 ? row?.salary_2 : row?.salary_2?.toFixed(2) || "NA"}</StyledTableCell>}
                                                            {[6].includes(activeTab?.value) && <StyledTableCell>{row?.salary_3 % 1 === 0 ? row?.salary_3 : row?.salary_3?.toFixed(2) || "NA"}</StyledTableCell>}
                                                            {[6].includes(activeTab?.value) && <StyledTableCell>{row?.salary_4 % 1 === 0 ? row?.salary_4 : row?.salary_4?.toFixed(2) || "NA"}</StyledTableCell>}
                                                            {[6].includes(activeTab?.value) && <StyledTableCell>{row?.salary_5 % 1 === 0 ? row?.salary_5 : row?.salary_5?.toFixed(2) || "NA"}</StyledTableCell>}

                                                            {[9].includes(activeTab?.value) && <StyledTableCell>{row?.c1 || "NA"}</StyledTableCell>}
                                                            {[9].includes(activeTab?.value) && <StyledTableCell>{row?.c2 || "NA"}</StyledTableCell>}
                                                            {[9].includes(activeTab?.value) && <StyledTableCell>{row?.c3 || "NA"}</StyledTableCell>}
                                                            {[9].includes(activeTab?.value) && <StyledTableCell>{row?.c4 || "NA"}</StyledTableCell>}
                                                            {[9].includes(activeTab?.value) && <StyledTableCell>{row?.c5 || "NA"}</StyledTableCell>}
                                                            {[9].includes(activeTab?.value) && <StyledTableCell>{row?.c6 || "NA"}</StyledTableCell>}
                                                            {[9].includes(activeTab?.value) && <StyledTableCell>in (KG)</StyledTableCell>}
                                                            {[9].includes(activeTab?.value) && <StyledTableCell>in (Sqmt)</StyledTableCell>}

                                                            {[7].includes(activeTab?.value) && <StyledTableCell>{row?.bankCharge || "Na"}</StyledTableCell>}
                                                            {[6, 7].includes(activeTab?.value) && <StyledTableCell>{row?.total || "NA"}</StyledTableCell>}
                                                            {[8].includes(activeTab?.value) && <StyledTableCell>{row?.quantity || "NA"}</StyledTableCell>}

                                                            {[11].includes(activeTab?.value) && <StyledTableCell>{row?.production || "0"}</StyledTableCell>}
                                                            {[11].includes(activeTab?.value) && <StyledTableCell>{row?.salary || "0"}</StyledTableCell>}
                                                            {[11].includes(activeTab?.value) && <StyledTableCell>{row?.bank || "0"}</StyledTableCell>}
                                                            {[11].includes(activeTab?.value) && <StyledTableCell>{row?.lightbill || "0"}</StyledTableCell>}
                                                            {[11].includes(activeTab?.value) && <StyledTableCell>{row?.pf || "0"}</StyledTableCell>}
                                                            {[11].includes(activeTab?.value) && <StyledTableCell>{row?.gas || "0"}</StyledTableCell>}
                                                            {[11].includes(activeTab?.value) && <StyledTableCell>
                                                                {row?.total
                                                                    ? Number(row.total)?.toFixed(row.total % 1 !== 0 ? 2 : 0)
                                                                    : "0"}
                                                            </StyledTableCell>}

                                                            {[12].includes(activeTab?.value) && <StyledTableCell>{row?.advanceLicenseNo || "0"}</StyledTableCell>}
                                                            {[12].includes(activeTab?.value) && (
                                                                <StyledTableCell>
                                                                    {row?.advanceLicenseDate
                                                                        ? new Date(row.advanceLicenseDate).toLocaleDateString()
                                                                        : "0"}
                                                                </StyledTableCell>
                                                            )}
                                                            {[12].includes(activeTab?.value) && <StyledTableCell>{row?.totalImportQty || "0"}</StyledTableCell>}
                                                            {[12].includes(activeTab?.value) && <StyledTableCell>{Number(row?.totalImportValue).toFixed(3) || "0"}</StyledTableCell>}
                                                            {[12].includes(activeTab?.value) && <StyledTableCell>{row?.unusedImportQty || "0"}</StyledTableCell>}
                                                            {[12].includes(activeTab?.value) && <StyledTableCell>{Number(row?.unusedImportValue).toFixed(3) || "0"}</StyledTableCell>}
                                                            {[12].includes(activeTab?.value) && <StyledTableCell>{row?.usedImportQty || "0"}</StyledTableCell>}
                                                            {[12].includes(activeTab?.value) && <StyledTableCell>{Number(row?.usedImportValue).toFixed(3) || "0"}</StyledTableCell>}
                                                            {[12].includes(activeTab?.value) && <StyledTableCell>{row?.totalExportQty || "0"}</StyledTableCell>}
                                                            {[12].includes(activeTab?.value) && <StyledTableCell>{Number(row?.totalExportValue).toFixed(3) || "0"}</StyledTableCell>}
                                                            {[12].includes(activeTab?.value) && <StyledTableCell>{row?.unusedExportQty || "0"}</StyledTableCell>}
                                                            {[12].includes(activeTab?.value) && <StyledTableCell>{Number(row?.unusedExportValue).toFixed(3) || "0"}</StyledTableCell>}
                                                            {[12].includes(activeTab?.value) && <StyledTableCell>{row?.usedExportQty || "0"}</StyledTableCell>}
                                                            {[12].includes(activeTab?.value) && <StyledTableCell>{Number(row?.usedExportValue ).toFixed(3) || "0"}</StyledTableCell>}

                                                            {[0, 1, 2, 3, 4, 10, 12].includes(activeTab?.value) && <StyledTableCell>
                                                                {row?.document ?
                                                                    <Box display={"flex"} gap={1} alignItems={"center"}>
                                                                        <Assets absolutePath={true} src={`/assets/img/Pdf.svg`} />
                                                                        {row?.document?.split("/").pop()}
                                                                    </Box>
                                                                    :
                                                                    "NA"
                                                                }
                                                            </StyledTableCell>}
                                                            {[12].includes(activeTab?.value) &&
                                                                <StyledTableCell>
                                                                    <StatusButton text={row.status == 2 ? "Not In Use" : "In Use"} color={row.status == 2 ? "gray" : "success"} />
                                                                </StyledTableCell>}
                                                            {![11].includes(activeTab?.value) &&
                                                                <StyledTableCell>
                                                                    <Box display={"flex"} gap={1}>
                                                                        {getPermissionList?.viewPermission?.includes('Documents') &&
                                                                            <IconBackground icon={"visibility"} onClick={() => { _getDocumentById(row?._id) }} />
                                                                        }
                                                                        {getPermissionList?.editPermission?.includes('Documents') &&
                                                                            <IconBackground icon={"delete"} disabled={(activeTab?.value == 12 && row.status == 1)}
                                                                                onClick={(e) => {
                                                                                    confirmDialogue({
                                                                                        title: `Are you sure you want to delete?`,
                                                                                    }).then(() => {
                                                                                        _deleteDocument(row?._id)
                                                                                    }).catch((err) => { console.error(err) });
                                                                                }} />
                                                                        }
                                                                    </Box>
                                                                </StyledTableCell>
                                                            }
                                                        </StyledTableRow>
                                                    </React.Fragment>
                                                ))
                                                :
                                                <StyledTableRow>
                                                    <StyledTableCell colSpan={12}>
                                                        <NoDataFound />
                                                    </StyledTableCell>
                                                </StyledTableRow>
                                            }
                                            {(listData?.response?.length > 0 && activeTab?.value == 6) && (
                                                <StyledTableRow>
                                                    <StyledTableCell sx={{ fontFamily: "Satoshi-Bold !important" }}>Total</StyledTableCell>
                                                    <StyledTableCell sx={{ fontFamily: "Satoshi-Bold !important" }}>
                                                        {(() => {
                                                            const total = listData?.response.reduce((sum, row) => sum + (row?.salary_1 || 0), 0);
                                                            return total % 1 === 0 ? total : total?.toFixed(2);
                                                        })()}
                                                    </StyledTableCell>
                                                    <StyledTableCell sx={{ fontFamily: "Satoshi-Bold !important" }}>
                                                        {(() => {
                                                            const total = listData?.response.reduce((sum, row) => sum + (row?.salary_2 || 0), 0);
                                                            return total % 1 === 0 ? total : total?.toFixed(2);
                                                        })()}
                                                    </StyledTableCell>
                                                    <StyledTableCell sx={{ fontFamily: "Satoshi-Bold !important" }}>
                                                        {(() => {
                                                            const total = listData?.response.reduce((sum, row) => sum + (row?.salary_3 || 0), 0);
                                                            return total % 1 === 0 ? total : total?.toFixed(2);
                                                        })()}
                                                    </StyledTableCell>
                                                    <StyledTableCell sx={{ fontFamily: "Satoshi-Bold !important" }}>
                                                        {(() => {
                                                            const total = listData?.response.reduce((sum, row) => sum + (row?.salary_4 || 0), 0);
                                                            return total % 1 === 0 ? total : total?.toFixed(2);
                                                        })()}
                                                    </StyledTableCell>
                                                    <StyledTableCell sx={{ fontFamily: "Satoshi-Bold !important" }}>
                                                        {(() => {
                                                            const total = listData?.response.reduce((sum, row) => sum + (row?.salary_5 || 0), 0);
                                                            return total % 1 === 0 ? total : total?.toFixed(2);
                                                        })()}
                                                    </StyledTableCell>
                                                    <StyledTableCell sx={{ fontFamily: "Satoshi-Bold !important" }}>
                                                        {(() => {
                                                            const total = listData?.response.reduce((sum, row) => sum + (row?.total || 0), 0);
                                                            return total % 1 === 0 ? total : total?.toFixed(2);
                                                        })()}
                                                    </StyledTableCell>
                                                </StyledTableRow>
                                            )}
                                            {(listData?.response?.length > 0 && activeTab?.value == 11) && (
                                                <StyledTableRow>
                                                    <StyledTableCell sx={{ fontFamily: "Satoshi-Bold !important" }}>Total</StyledTableCell>

                                                    <StyledTableCell sx={{ fontFamily: "Satoshi-Bold !important" }}>
                                                        {(() => {
                                                            const total = listData?.response.reduce((sum, row) => sum + (row?.production || 0), 0);
                                                            return total % 1 === 0 ? total : total?.toFixed(2);
                                                        })()}
                                                    </StyledTableCell>
                                                    <StyledTableCell sx={{ fontFamily: "Satoshi-Bold !important" }}>
                                                        {(() => {
                                                            const total = listData?.response.reduce((sum, row) => sum + (row?.salary || 0), 0);
                                                            return total % 1 === 0 ? total : total?.toFixed(2);
                                                        })()}

                                                    </StyledTableCell>
                                                    <StyledTableCell sx={{ fontFamily: "Satoshi-Bold !important" }}>
                                                        {(() => {
                                                            const total = listData?.response.reduce((sum, row) => sum + (row?.bank || 0), 0);
                                                            return total % 1 === 0 ? total : total?.toFixed(2);
                                                        })()}

                                                    </StyledTableCell>
                                                    <StyledTableCell sx={{ fontFamily: "Satoshi-Bold !important" }}>
                                                        {(() => {
                                                            const total = listData?.response.reduce((sum, row) => sum + (row?.lightbill || 0), 0);
                                                            return total % 1 === 0 ? total : total?.toFixed(2);
                                                        })()}

                                                    </StyledTableCell>
                                                    <StyledTableCell sx={{ fontFamily: "Satoshi-Bold !important" }}>
                                                        {(() => {
                                                            const total = listData?.response.reduce((sum, row) => sum + (row?.pf || 0), 0);
                                                            return total % 1 === 0 ? total : total?.toFixed(2);
                                                        })()}

                                                    </StyledTableCell>
                                                    <StyledTableCell sx={{ fontFamily: "Satoshi-Bold !important" }}>
                                                        {(() => {
                                                            const total = listData?.response.reduce((sum, row) => sum + (row?.gas || 0), 0);
                                                            return total % 1 === 0 ? total : total?.toFixed(2);
                                                        })()}

                                                    </StyledTableCell>
                                                    <StyledTableCell sx={{ fontFamily: "Satoshi-Bold !important" }}>
                                                        {(() => {
                                                            const total = listData?.response.reduce((sum, row) => sum + (row?.total || 0), 0);
                                                            return total % 1 === 0 ? total : total?.toFixed(2);
                                                        })()}
                                                    </StyledTableCell>

                                                    {/* More columns for totals here... */}
                                                </StyledTableRow>
                                            )}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                {[1, 3, 12].includes(activeTab?.value) &&
                                    <CommonPagination
                                        totalCount={listData?.count}
                                        count={Math.ceil(listData?.count / PerPage)}
                                        itemsPerPage={PerPage}
                                        page={page}
                                        onChange={handleChangePage}
                                    />
                                }
                            </Box>
                    }
                </Grid>
            </Grid>
            <CustomDrawer
                isDrawerOpen={isOpenDrawer}
                handleClose={() => { setIsOpenDrawer(false); setSelectedItem({}); setData({}) }}
                title={activeTab?.value === 6 ? "Add Salary" : activeTab?.value === 8 ? "Add Gas Document" : `${selectedItem?._id ? "Edit" : "Add"} ${activeTab?.name}`}
            >
                <AddUpdateDocument data={data} setData={setData} activeTab={activeTab} setSelectedItem={setSelectedItem} selectedItem={selectedItem} setIsOpenDrawer={setIsOpenDrawer} yearOptions={yearOptions} _getDocuments={_getDocuments} />
            </CustomDrawer>
            <CustomDrawer
                isDrawerOpen={isOpenViewDrawer}
                handleClose={() => { setIsOpenViewDrawer(false); setSelectedItem({}); setData({}); setPoDocumentByLicenseData({}) }}
                title={`${activeTab?.name}`}
            >
                <ViewDocument _getPoDocumentsByAdvanceLicense={_getPoDocumentsByAdvanceLicense} poDocumentByLicenseData={poDocumentByLicenseData} activeTab={activeTab} selectedItem={selectedItem} />
            </CustomDrawer>
        </Box >
    );
};

export default Documents;

const LightBillTable = ({ listData, _deleteDocument, _getDocumentById }) => {
    const theme = useTheme();
    const confirmDialogue = useConfirm();
    const locations = ["Location_1", "Location_2", "Location_3", "Location_4", "Location_5", "Location_6"];

    const getPermissionList = useAppSelector((state) => state?.auth?.getRolePermission);

    const sortByFinancialYear = (data) => {
        const financialYearOrder = [4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3];

        return data?.sort((a, b) =>
            financialYearOrder.indexOf(a.month) - financialYearOrder.indexOf(b.month)
        );
    };

    return (
        <Box sx={{ borderRadius: "26px", border: "1px solid", backgroundColor: theme.palette.bgWhite.main, borderColor: "#c8d3d96e", borderTop: "none" }}>
            <TableContainer>
                <Table sx={{ borderBottom: '1px solid #c8d3d96e' }}>
                    <TableHead>
                        <StyledTableRow isBordered isHeader style={{ backgroundColor: "#E9E9E9" }}>
                            <StyledTableCell isBordered style={{ borderBottomLeftRadius: "0px", borderRight: "1px solid #0000001a", borderBottom: "1px solid #0000001a" }}>Month</StyledTableCell>
                            {locations?.map((ele) => (
                                <StyledTableCell key={ele} isBordered colSpan={3} align='center' style={{ borderRight: "1px solid #0000001a", borderBottom: "1px solid #0000001a" }}>
                                    {ele}
                                </StyledTableCell>
                            ))}
                            <StyledTableCell isBordered align="center" style={{ borderRight: "1px solid #0000001a", borderBottom: "1px solid #0000001a" }}>Total</StyledTableCell>
                            <StyledTableCell isBordered style={{ borderBottomRightRadius: "0px", borderBottom: "1px solid #0000001a" }}>Actions</StyledTableCell>
                        </StyledTableRow>
                        <StyledTableRow isBordered>
                            <StyledTableCell isBordered align="center">-</StyledTableCell>
                            {Array.from({ length: locations.length }).map((_, index) => (
                                <React.Fragment key={index}>
                                    <StyledTableCell isBordered align="center">Unit</StyledTableCell>
                                    <StyledTableCell isBordered align="center">Amount</StyledTableCell>
                                    <StyledTableCell isBordered align="center">Document</StyledTableCell>
                                </React.Fragment>
                            ))}
                            <StyledTableCell isBordered align="center">-</StyledTableCell>
                            <StyledTableCell isBordered align="center">-</StyledTableCell>
                        </StyledTableRow>
                    </TableHead>

                    <TableBody>
                        {listData?.response?.length > 0 ? (
                            sortByFinancialYear(listData?.response)?.map((row, rowIndex) => {
                                const rowTotal = row?.light_bill?.reduce((sum, ele) => sum + (ele?.amount || 0), 0);
                                return (
                                    <StyledTableRow key={rowIndex} isBordered>
                                        <StyledTableCell isBordered>
                                            {row?.month ? monthsOption?.find((ele) => row?.month === ele?.id)?.name : "NA"}
                                        </StyledTableCell>

                                        {row?.light_bill?.length > 0 ? (
                                            row?.light_bill?.map((ele, idx) => (
                                                <React.Fragment key={`${rowIndex}-${idx}`}>
                                                    <StyledTableCell isBordered align="center">{ele?.unit || "NA"}</StyledTableCell>
                                                    <StyledTableCell isBordered align="center"> {ele?.amount
                                                        ? Number(ele.amount)?.toFixed(ele.amount % 1 !== 0 ? 2 : 0)
                                                        : "NA"}</StyledTableCell>
                                                    <StyledTableCell isBordered align="center">
                                                        {ele?.document ?
                                                            <Box display="flex" gap={1} alignItems="center">
                                                                <Assets absolutePath src="/assets/img/Pdf.svg" />
                                                                {ele?.document?.split("/").pop()}
                                                            </Box>
                                                            :
                                                            "NA"
                                                        }
                                                    </StyledTableCell>
                                                </React.Fragment>
                                            ))
                                        ) : (
                                            locations?.map((_, idx) => (
                                                <React.Fragment key={`${rowIndex}-empty-${idx}`}>
                                                    <StyledTableCell isBordered align="center">-</StyledTableCell>
                                                    <StyledTableCell isBordered align="center">-</StyledTableCell>
                                                    <StyledTableCell isBordered align="center">-</StyledTableCell>
                                                </React.Fragment>
                                            ))
                                        )}



                                        <StyledTableCell isBordered align="center" style={{ fontWeight: "bold" }}>
                                            {rowTotal % 1 === 0 ? rowTotal : rowTotal?.toFixed(2)}
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            <Box display="flex" gap={1}>
                                                {getPermissionList?.viewPermission?.includes('Documents') &&
                                                    <IconBackground icon="visibility" onClick={() => _getDocumentById(row?._id)} />
                                                }
                                                {getPermissionList?.editPermission?.includes('Documents') &&
                                                    <IconBackground icon="delete"
                                                        onClick={(e) => {
                                                            confirmDialogue({
                                                                title: `Are you sure you want to delete?`,
                                                            }).then(() => {
                                                                _deleteDocument(row?._id)
                                                            }).catch((err) => { console.error(err) });
                                                        }}
                                                    />
                                                }
                                            </Box>
                                        </StyledTableCell>
                                    </StyledTableRow>
                                );
                            })
                        ) : (
                            <StyledTableRow>
                                <StyledTableCell colSpan={locations.length * 3 + 3}>
                                    <NoDataFound />
                                </StyledTableCell>
                            </StyledTableRow>
                        )}
                        {listData?.response?.length > 0 && (
                            <StyledTableRow isBordered>
                                <StyledTableCell isBordered align="center" style={{ fontFamily: "Satoshi-Bold" }}>
                                    Total
                                </StyledTableCell>

                                {locations.map((location, index) => {
                                    const totalUnit = listData?.response?.reduce((sum, row) => {
                                        return sum + row?.light_bill?.reduce(
                                            (subSum, ele) => ele?.location_name === location ? subSum + (ele?.unit || 0) : subSum,
                                            0
                                        );
                                    }, 0);

                                    const totalAmount = listData?.response?.reduce((sum, row) => {
                                        return sum + row?.light_bill?.reduce(
                                            (subSum, ele) => ele?.location_name === location ? subSum + (ele?.amount || 0) : subSum,
                                            0
                                        );
                                    }, 0);

                                    return (
                                        <React.Fragment key={index}>
                                            <StyledTableCell style={{ fontFamily: "Satoshi-Bold" }} isBordered align="center">
                                                {totalUnit}
                                            </StyledTableCell>
                                            <StyledTableCell style={{ fontFamily: "Satoshi-Bold" }} isBordered align="center">
                                                {totalAmount?.toFixed(
                                                    listData?.response?.some(row =>
                                                        row?.light_bill?.some(ele => ele?.amount % 1 !== 0)
                                                    ) ? 2 : 0
                                                )}
                                            </StyledTableCell>
                                            <StyledTableCell style={{ fontFamily: "Satoshi-Bold" }} isBordered align="center">-</StyledTableCell>
                                        </React.Fragment>
                                    );
                                })}

                                <StyledTableCell isBordered align="center" style={{ fontFamily: "Satoshi-Bold" }}>
                                    {listData?.response?.reduce((sum, row) => sum + row?.light_bill?.reduce((subSum, ele) => subSum + (ele?.amount || 0), 0), 0).toFixed(
                                        listData?.response?.some(row =>
                                            row?.light_bill?.some(ele => ele?.amount % 1 !== 0)
                                        ) ? 2 : 0
                                    )}
                                </StyledTableCell>

                                <StyledTableCell isBordered>-</StyledTableCell>
                            </StyledTableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>

        </Box>
    )
}

const ProductionTable = ({ listData, _deleteDocument, _getDocumentById }) => {
    const theme = useTheme();
    const confirmDialogue = useConfirm();
    const locations = ["C1", "C2", "C3", "C4", "C5", "C6", "Total"];
    const getPermissionList = useAppSelector((state) => state?.auth?.getRolePermission);


    const sortByFinancialYear = (data) => {
        const financialYearOrder = [4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3];

        return data?.sort((a, b) =>
            financialYearOrder.indexOf(a.month) - financialYearOrder.indexOf(b.month)
        );
    };
    return (
        <Box sx={{ borderRadius: "26px", border: "1px solid", backgroundColor: theme.palette.bgWhite.main, borderColor: "#c8d3d96e", borderTop: "none" }}>
            <TableContainer>
                <Table sx={{ borderBottom: '1px solid #c8d3d96e' }}>
                    <TableHead>
                        <StyledTableRow isBordered isHeader style={{ backgroundColor: "#E9E9E9" }}>
                            <StyledTableCell isBordered style={{ borderBottomLeftRadius: "0px", borderRight: "1px solid #0000001a", borderBottom: "1px solid #0000001a" }}>Month</StyledTableCell>
                            {locations?.map((ele) => (
                                <StyledTableCell key={ele} isBordered colSpan={2} align='center' style={{ borderRight: "1px solid #0000001a", borderBottom: "1px solid #0000001a" }}>
                                    {ele}
                                </StyledTableCell>
                            ))}
                            <StyledTableCell isBordered style={{ borderBottomRightRadius: "0px", borderBottom: "1px solid #0000001a" }}>Actions</StyledTableCell>
                        </StyledTableRow>
                        <StyledTableRow isBordered>
                            <StyledTableCell isBordered align="center">-</StyledTableCell>
                            {Array.from({ length: locations.length }).map((_, index) => (
                                <React.Fragment key={index}>
                                    <StyledTableCell isBordered align="center">Kg</StyledTableCell>
                                    <StyledTableCell isBordered align="center">sqmt</StyledTableCell>
                                </React.Fragment>
                            ))}
                            <StyledTableCell isBordered align="center">-</StyledTableCell>
                        </StyledTableRow>
                    </TableHead>

                    <TableBody>
                        {listData?.response?.length > 0 ? (
                            sortByFinancialYear(listData?.response)?.map((row, rowIndex) => {
                                return (
                                    <StyledTableRow key={rowIndex} isBordered>
                                        <StyledTableCell isBordered>
                                            {row?.month ? monthsOption?.find((ele) => row?.month === ele?.id)?.name : "NA"}
                                        </StyledTableCell>

                                        {["c1", "c2", "c3", "c4", "c5", "c6"].map((field, idx) => (
                                            <React.Fragment key={idx}>
                                                <StyledTableCell isBordered align="center">
                                                    {row[`${field}_kg`] || "-"}
                                                </StyledTableCell>
                                                <StyledTableCell isBordered align="center">
                                                    {row[`${field}_sqmt`] || "-"}
                                                </StyledTableCell>
                                            </React.Fragment>
                                        ))}

                                        <StyledTableCell isBordered align="center" style={{ fontWeight: "bold" }}>
                                            {row?.total || "-"}
                                        </StyledTableCell>
                                        <StyledTableCell isBordered align="center" style={{ fontWeight: "bold" }}>
                                            {row?.second_total || "-"}
                                        </StyledTableCell>

                                        <StyledTableCell>
                                            <Box display="flex" gap={1}>
                                                {getPermissionList?.viewPermission?.includes('Documents') &&
                                                    <IconBackground icon="visibility" onClick={() => _getDocumentById(row?._id)} />
                                                }
                                                {getPermissionList?.editPermission?.includes('Documents') &&
                                                    <IconBackground icon="delete"
                                                        onClick={(e) => {
                                                            confirmDialogue({
                                                                title: `Are you sure you want to delete?`,
                                                            }).then(() => {
                                                                _deleteDocument(row?._id)
                                                            }).catch((err) => { console.error(err) });
                                                        }}
                                                    />
                                                }
                                            </Box>
                                        </StyledTableCell>
                                    </StyledTableRow>
                                );
                            })
                        ) : (
                            <StyledTableRow>
                                <StyledTableCell colSpan={locations.length * 3 + 3}>
                                    <NoDataFound />
                                </StyledTableCell>
                            </StyledTableRow>
                        )}
                        {listData?.response?.length > 0 && (
                            <StyledTableRow isBordered>
                                <StyledTableCell isBordered align="center" style={{ fontFamily: "Satoshi-Bold" }}>Total</StyledTableCell>
                                {["c1", "c2", "c3", "c4", "c5", "c6"].map((field, index) => (
                                    <React.Fragment key={index}>
                                        <StyledTableCell style={{ fontFamily: "Satoshi-Bold" }} isBordered align="center">
                                            {listData?.response?.reduce((sum, row) => sum + (row[`${field}_kg`] || 0), 0)}
                                        </StyledTableCell>
                                        <StyledTableCell style={{ fontFamily: "Satoshi-Bold" }} isBordered align="center">
                                            {listData?.response?.reduce((sum, row) => sum + (row[`${field}_sqmt`] || 0), 0)}
                                        </StyledTableCell>
                                    </React.Fragment>
                                ))}
                                <StyledTableCell isBordered align="center" style={{ fontFamily: "Satoshi-Bold" }}>
                                    {listData?.response?.reduce((sum, row) => sum + (row?.total || 0), 0)}
                                </StyledTableCell>

                                <StyledTableCell isBordered align="center" style={{ fontFamily: "Satoshi-Bold" }}>
                                    {listData?.response?.reduce((sum, row) => sum + (row?.second_total || 0), 0)}
                                </StyledTableCell>
                                <StyledTableCell isBordered align="center" style={{ fontFamily: "Satoshi-Bold" }}>
                                    -
                                </StyledTableCell>
                            </StyledTableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>

        </Box>
    )
}